var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Backer'),_vm._v(" "),_c('div',{staticClass:"fm-container"},[(Object.keys(_vm.product_data).length > 0)?_c('div',[_c('Product',{attrs:{"viewdata":_vm.product_data}})],1):_vm._e()])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c98bd2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewProduct.vue
// module id = null
// module chunks = 